import React from 'react';
import LoungeXS from './LoungeXS';
import LoungeS from './LoungeS';
import LoungeM from './LoungeM';
const Lounge = ({ size, ...props }) => {
    switch (size) {
        case 16:
            return React.createElement(LoungeXS, Object.assign({}, props));
        case 24:
            return React.createElement(LoungeS, Object.assign({}, props));
        case 32:
            return React.createElement(LoungeM, Object.assign({}, props));
        default:
            return React.createElement(LoungeXS, Object.assign({}, props));
    }
};
export default Lounge;
//# sourceMappingURL=Lounge.js.map